export default __webpack_public_path__ + "static/media/character-yeti-idle.96c90338.png";